class EdgeDesignsFullwidth extends HTMLElement {
  connectedCallback() {
    this.tabElement = this.querySelector('tab-element');
    this.panels = this.querySelectorAll('.edge-image-panel');

    if (!this.tabElement) return;

    this.tabElement.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      const index = parseInt(tab.dataset.tabIndex, 10);
      if (isNaN(index)) return;

      this.#showPanel(index);
    });
  }

  #showPanel(activeIndex) {
    let panelIndex = 0;
    for (const panel of this.panels) {
      const isActive = panelIndex === activeIndex;

      panel.setAttribute('aria-hidden', String(!isActive));
      panel.classList.toggle('opacity-100', isActive);
      panel.classList.toggle('opacity-0', !isActive);
      panel.classList.toggle('pointer-events-none', !isActive);
      panel.classList.toggle('absolute', !isActive);
      panel.classList.toggle('inset-0', !isActive);

      panelIndex++;
    }
  }
}

customElements.define('edge-designs-fullwidth', EdgeDesignsFullwidth);
